namespace SP {
    let _zoom = 1;
    
    export function zoom(amount: number = null) {
        if (amount == null) {
            var styleZ = (window.getComputedStyle(document.body) as any).zoom;
            if (styleZ) return parseFloat(styleZ);
            return _zoom;
           // return _zoom;
        }


        _zoom = amount;
        (document.body.style as any).zoom = _zoom.toString();
        return _zoom;
    }
}